<script lang="ts" setup>
import { useShortCount } from "@/use/common";
import Multiselect from "@vueform/multiselect";
import { usePresetTags } from "@/composable/settings/tag";
import { computed } from "vue";

const props = defineProps<{
  tag: string[];
}>();

const emit = defineEmits<{
  (e: "update:tag", val: string[]): void;
}>();

const { mergedTags } = usePresetTags();

const tagList = computed(() => {
  const { tag } = props;

  const allTagsMap: Record<string, boolean> = {};
  mergedTags.value.forEach((item) => {
    allTagsMap[item.value] = true;
  });
  const customTags: string[] = [];
  tag.forEach((key) => {
    if (!allTagsMap[key]) {
      customTags.push(key);
    }
  });
  return [
    ...mergedTags.value,
    ...customTags.map((item) => ({
      label: item,
      value: item,
    })),
  ];
});
</script>
<template>
  <Multiselect
    :appendNewOption="false"
    :close-on-select="false"
    :createOption="true"
    :max="7"
    :model-value="tag"
    :options="tagList"
    :placeholder="$t('Message.none')"
    class=""
    mode="tags"
    searchable
    @update:modelValue="emit('update:tag', $event)"
  >
    <template #option="{ option }">
      <span class="flex items-center justify-between flex-grow">
        <span class="flex gap-1 items-center">
          <span
            v-if="!mergedTags.find((item) => item.value === option.value)"
            class="badge badge-sm badge-info"
          >
            {{ $t("Message.createNewTag") }}
          </span>
          {{ option.label }}
        </span>
        <span class="flex items-center gap-1">
          <i v-if="option.isPreset" class="iconify mingcute--tag-line" />
          <span v-if="option.count">{{ useShortCount(option.count) }}</span>
        </span>
      </span>
    </template>
    <template #clear="{ clear }">
      <button
        class="flex items-center px-2 text-base-content/50 hover:text-base-content focus:outline-none"
        title="Clear the field"
        type="button"
        @click="clear"
      >
        <i class="iconify mingcute--close-line text-[10px]" />
      </button>
    </template>
    <template #caret="{ handleCaretClick, isOpen }">
      <button
        class="multiselect-caret"
        title="Clear the field"
        type="button"
        @click="handleCaretClick"
      >
        <i
          :class="[
            'text-xs iconify',
            isOpen ? 'mingcute--up-line' : 'mingcute--down-line',
          ]"
        />
      </button>
    </template>
  </Multiselect>
</template>
